export default __webpack_public_path__ + "static/nail-salon-screen-49798fba7051fc725b016fa147a2cb0e.svg";